import {
  searchAirApi,
  searchBXAirApi,
  selectNextPriceAPI,
  getResponseKeyFromMultiBrandKey,
  isSkipCalendarApi,
  searchAirCloudApi,
} from '../../services/api/search.service';
import { moveNext } from './workflow';
import {
  selectActiveComponentIndex,
  selectTripResults,
  selectSearchInput,
} from '../selectors/search.selector';
import { updateSelectedAward } from './search';
import {
  selectAirSearchResults,
  selectActiveAirComponent,
  selectDepartureAirportList,
  selectArrivalAirportList,
  selectResultsFilteredByBrand,
  selectCloudResultsFilteredByBrand,
  selectSelectedMultibrandKey,
  selectLowestFareForLeg1,
  selectDepartureAirportListCloud,
  selectArrivalAirportListCloud,
  selectAirBrands,
  selectCloudLowestFareForLeg1,
} from '../selectors/air.selector';
import to from '../../utils/to';
import i18n from '../../i18n';
import * as RootNavigation from '../../utils/navigationRef';
import { openAlert } from './alert';
import {
  getBrandsAvailable,
  getAirFiltersByDetails,
  getBrandsAvailableCloud,
  getAirFiltersByDetailsCloud,
  getAirFilterByAlternateAirports,
} from '../../utils/air.util';
import { logException } from '../../utils/logger.utils';
import { selectAccessToken, selectCompanyConfig } from '../selectors/auth.selector';
import { selectTezEvent } from '../selectors/events.selector';
import { searchSubTypeToAirRequestTypeMap, searchTypesEnum } from '../../constants/Enums';
import zlib from 'react-zlib-js';
import { TRIPHUB_ENABLED, TRIPEVENTS_ENABLED, AA_ENABLED } from '../../config/env';
import { Buffer } from 'buffer';

export const SET_AIR_RESULTS = 'SET_AIR_RESULTS';
export const SELECT_AIR = 'SELECT_AIR';
export const CLEAR_AIR = 'CLEAR_AIR';
export const ORDER_BY_AIR = 'ORDER_BY_AIR';
export const ORDER_BY_REVERSE_AIR = 'ORDER_BY_REVERSE_AIR';
export const FILTER_BY_AIR = 'FILTER_BY_AIR';
export const FILTER_BY_AIR_BRAND = 'FILTER_BY_AIR_BRAND';
export const FILTER_BY_AIR_STOP_AND_VENDOR = 'FILTER_BY_AIR_STOP_AND_VENDOR';
export const UPDATE_TRIP_SEARCH_RESULTS = 'UPDATE_TRIP_SEARCH_RESULTS';
export const UPDATE_SEARCH_INPUT_DATES = 'UPDATE_SEARCH_INPUT_DATES';
export const SET_CAR_PICKUP_DROPOFF_DATE = 'SET_CAR_PICKUP_DROPOFF_DATE';
export const SET_CAR_REQUEST_COMPONENT_ID = 'SET_CAR_REQUEST_COMPONENT_ID';

export const selectAir = (selectedAir, brand = null, legNumber) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const searchResults = selectAirSearchResults(getState());
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;
    const searchInput = selectSearchInput(getState());
    const accessToken = selectAccessToken(getState());
    const getCompanyCulture = selectCompanyConfig(getState());

    if (!brand) {
      brand = selectedAir.MultiBrands && selectedAir.MultiBrands[0];
    }

    const allCategoryMatrix = searchResults?.AirMatrixData.find((x) => x.CategoryName === 'All');
    const lowestFare =
      (allCategoryMatrix || allCategoryMatrix === 0) && allCategoryMatrix.LowestPrice;

    let newMultiBrandResponseKey;
    if (brand.MultiBrandID != '' && brand.MultiBrandID != '00000000-0000-0000-0000-000000000000') {
      newMultiBrandResponseKey = await getResponseKeyFromMultiBrandKey(
        accessToken,
        brand.MultiBrandID
      );
    }

    dispatch({
      type: SELECT_AIR,
      selectedAir,
      lowestFare,
      newMultiBrandResponseKey,
      brand,
      displayIndex,
      isAirCloud: false,
    });

    if (AA_ENABLED) {
      dispatch(updateSelectedAward(brand.AwardName));
    }

    const carRequestComponent = results.RequestedComponents.filter(
      (component) => component.ComponentName === searchTypesEnum.CAR
    )[0];

    if (carRequestComponent !== undefined) {
      let pickupDate = '';
      let dropoffDate = '';
      if (legNumber === 1) {
        const firstLegLastSegment = selectedAir?.AirLegs[0]?.AirSegments?.slice(-1)[0];
        pickupDate = `${firstLegLastSegment?.ArrivalDate} ${firstLegLastSegment?.ArrivalTime}`;
      } else {
        pickupDate = carRequestComponent?.pickupDate;
        const secondLegFirstSegment = selectedAir?.AirLegs[0]?.AirSegments[0];
        dropoffDate = `${secondLegFirstSegment?.DepartureDate} ${secondLegFirstSegment?.DepartTime}`;
      }
      dispatch({
        type: SET_CAR_PICKUP_DROPOFF_DATE,
        componentType: searchTypesEnum.CAR,
        legNumber,
        pickupDate,
        dropoffDate,
      });
      if (
        legNumber === 2 ||
        searchInput.airRequestType === searchSubTypeToAirRequestTypeMap.oneway
      ) {
        const [err, carComponentId] = await to(
          selectNextPriceAPI(
            pickupDate,
            dropoffDate,
            travelRequestId,
            searchInput,
            accessToken,
            getCompanyCulture
          )
        );

        if (err) {
          dispatch(
            openAlert({
              title: 'Select Next Price Failed',
              confirmText: i18n.t('ReSearch'),
              onConfirmPressed: () => RootNavigation.navigate('AASearchScreen'),
            })
          );
          logException(err, { metaData: { travelRequestId } });
          return;
        }

        dispatch({
          type: SET_CAR_REQUEST_COMPONENT_ID,
          componentType: searchTypesEnum.CAR,
          carComponentId,
        });
      }
    }
    dispatch(moveNext());
  };
};
async function handleAirCarCombo(data) {
  const {
    dispatch,
    selectedAir,
    carRequestComponent,
    legNumber,
    searchInput,
    travelRequestId,
    accessToken,
    getCompanyCulture,
  } = data;
  let pickupDate = '';
  let dropoffDate = '';
  if (legNumber === 1) {
    if (selectedAir?.legs[0]?.flights) {
      pickupDate = `${selectedAir?.legs[0]?.flights?.slice(-1)[0]?.arrivalDate} ${
        selectedAir?.legs[0]?.flights?.slice(-1)[0]?.arrivalTime
      }`;
    }
  } else {
    pickupDate = carRequestComponent?.pickupDate;
    dropoffDate = `${selectedAir?.legs[0]?.flights[0]?.departureDate} ${selectedAir?.legs[0]?.flights[0]?.departureTime}`;
  }
  dispatch({
    type: SET_CAR_PICKUP_DROPOFF_DATE,
    componentType: searchTypesEnum.CAR,
    legNumber,
    pickupDate,
    dropoffDate,
  });
  if (legNumber === 2 || searchInput.airRequestType === searchSubTypeToAirRequestTypeMap.oneway) {
    const [err, carComponentId] = await to(
      selectNextPriceAPI(
        pickupDate,
        dropoffDate,
        travelRequestId,
        searchInput,
        accessToken,
        getCompanyCulture
      )
    );

    if (err) {
      dispatch(
        openAlert({
          title: 'Select Next Price Failed',
          confirmText: i18n.t('ReSearch'),
          onConfirmPressed: () => RootNavigation.navigate('AASearchScreen'),
        })
      );
      logException(err, { metaData: { travelRequestId } });
      return;
    }
    dispatch({
      type: SET_CAR_REQUEST_COMPONENT_ID,
      componentType: searchTypesEnum.CAR,
      carComponentId,
    });
  }
}

export const selectAirCloud = (
  selectedAir,
  brand = null,
  legNumber,
  setFlightLoading,
  selectedBrandIndex
) => {
  return async (dispatch, getState) => {
    const state = getState();
    const displayIndex = selectActiveComponentIndex(getState());
    const searchResults = selectAirSearchResults(getState());
    const airBrands = selectAirBrands(getState());
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;
    const searchInput = selectSearchInput(state);
    const accessToken = selectAccessToken(getState());
    const getCompanyCulture = selectCompanyConfig(getState());

    // Create a new object with selectedAir and selectedBrand[setting the cabin]
    const updatedSelectedAir = {
      ...selectedAir,
      selectedBrand: selectedBrandIndex,
    };

    if (!brand) {
      brand = selectedAir.fares && selectedAir.fares[0];
    }
    const allCategoryMatrix = airBrands.find((x) => x.key === 'Lowest');
    const lowestFare =
      (allCategoryMatrix ||
        allCategoryMatrix === 0 ||
        searchResults?.minPrice === allCategoryMatrix.price) &&
      allCategoryMatrix.price;

    dispatch({
      type: SELECT_AIR,
      selectedAir: updatedSelectedAir, // Use the updated selectedAir object
      lowestFare,
      newMultiBrandResponseKey: brand.id,
      brand,
      displayIndex,
      isAirCloud: true,
    });

    const carRequestComponent = results.RequestedComponents.filter(
      (component) => component.ComponentName === searchTypesEnum.CAR
    )[0];

    if (carRequestComponent) {
      const data = {
        dispatch,
        selectedAir: updatedSelectedAir, // Use the updated selectedAir object
        carRequestComponent,
        legNumber,
        searchInput,
        travelRequestId,
        accessToken,
        getCompanyCulture,
      };
      await handleAirCarCombo(data);
    }
    setFlightLoading(false);
    dispatch(moveNext());
  };
};

export const getIsSkipCalendar = (authNumber) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;

    const [err, isSkipCalendar] = await to(
      isSkipCalendarApi(accessToken, authNumber, travelRequestId)
    );

    if (err) {
      dispatch(
        openAlert({
          title: 'IsSkipCalendar Failed',
          confirmText: i18n.t('ReSearch'),
          onConfirmPressed: () => RootNavigation.navigate('AASearchScreen'),
        })
      );
      logException(err, { metaData: { travelRequestId } });
      return;
    }
    return isSkipCalendar;
  };
};

export const airSearch = (
  routeParams,
  serviceType,
  airLeg1ResponseKey,
  selectedAirline,
  changeResTripInfo
) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const accessToken = selectAccessToken(getState());
    const results = selectTripResults(getState());
    const selectedMultibrandKey = selectSelectedMultibrandKey(getState());
    const selectedEvent = selectTezEvent(getState());
    const travelRequestId = results.TravelRequestId;
    const requestedComponents = results.RequestedComponents;
    const lowestFareForLeg1 = selectLowestFareForLeg1(getState());
    const airComponentRequestId = requestedComponents.find((x) => x.DisplayIndex === displayIndex)
      ?.ComponentRequestId;
    try {
      const [err, airSearchResults] = await to(
        searchAirApi(
          accessToken,
          travelRequestId,
          airComponentRequestId,
          routeParams,
          serviceType,
          airLeg1ResponseKey,
          selectedAirline,
          changeResTripInfo,
          selectedMultibrandKey,
          selectedEvent,
          lowestFareForLeg1
        )
      );

      if (err) {
        dispatch(
          openAlert({
            title: i18n.t('AirSearchFailureMessage'),
            confirmText: i18n.t('ReSearch'),
            onConfirmPressed: () => RootNavigation.navigate('Home'),
          })
        );
        logException(err, { metaData: { travelRequestId, airComponentRequestId } });
        return;
      }

      if (airSearchResults?.AirResponses) {
        airSearchResults.AirResponses = airSearchResults.AirResponses.map((result) => {
          // making sure first multibrand is the lowest for the default brand
          result.MultiBrands = result.MultiBrands?.filter((x) => x.IsLowestFare).sort(
            (a, b) => parseFloat(a.TotalFare) - parseFloat(b.TotalFare)
          );
          result.selectedBrand = 0;

          return result;
        });
      }

      const filterBrands = airSearchResults
        ? getBrandsAvailable(airSearchResults.AirResponses)
        : null;

      dispatch({
        type: SET_AIR_RESULTS,
        searchResults: airSearchResults,
        filterByBrand: filterBrands?.[0].brand,
        filterBrands,
        displayIndex,
      });

      const airResponses = selectResultsFilteredByBrand(getState());
      const departureAirportList = selectDepartureAirportList(getState());
      const arrivalAirportList = selectArrivalAirportList(getState());
      const filterByDetails = getAirFiltersByDetails(
        airResponses,
        departureAirportList,
        arrivalAirportList
      );

      dispatch(filterByStopAndVendor(filterByDetails));
    } catch (err) {
      dispatch(
        openAlert({
          title: i18n.t('AirSearchFailureMessage'),
          confirmText: i18n.t('ReSearch'),
          onConfirmPressed: () => RootNavigation.navigate('Home'),
        })
      );
      logException(err, { metaData: { travelRequestId, airComponentRequestId } });
      return;
    }
  };
};
export const airCloudSearch = (
  routeParams,
  serviceType,
  airLeg1ResponseKey,
  selectedAirline,
  changeResTripInfo
) => {
  return async (dispatch, getState) => {
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;
    const displayIndex = selectActiveComponentIndex(getState());
    const accessToken = selectAccessToken(getState());
    const selectedMultibrandKey = selectSelectedMultibrandKey(getState());
    const selectedEvent = selectTezEvent(getState());
    const requestedComponents = results.RequestedComponents;
    const lowestFareForLeg1 = selectCloudLowestFareForLeg1(getState());
    const airComponentRequestId = requestedComponents.find((x) => x.DisplayIndex === displayIndex)
      ?.ComponentRequestId;
    let airReqComponentRedisKey = requestedComponents.find((x) => x.DisplayIndex === displayIndex)
      ?.RedisCacheKey;
    if (airReqComponentRedisKey?.length > 1) {
      airReqComponentRedisKey = airReqComponentRedisKey?.join();
    } else {
      airReqComponentRedisKey = airReqComponentRedisKey && airReqComponentRedisKey[0];
    }
    try {
      const [err, resp] = await to(
        searchAirCloudApi(
          accessToken,
          travelRequestId,
          airComponentRequestId,
          routeParams,
          serviceType,
          airLeg1ResponseKey,
          selectedAirline,
          changeResTripInfo,
          selectedMultibrandKey,
          selectedEvent,
          lowestFareForLeg1,
          airReqComponentRedisKey
        )
      );
      if (err) {
        dispatch(
          openAlert({
            title: i18n.t('AirSearchFailureMessage'),
            confirmText: i18n.t('ReSearch'),
            onConfirmPressed: () => RootNavigation.navigate('Home'),
          })
        );
        logException(err, { metaData: { travelRequestId, airComponentRequestId } });
        return;
      }
      const buffer = Buffer?.from(resp, 'base64');
      const respDecompression = zlib.gunzipSync(buffer)?.toString();
      const airSearchResults = parseAndSortAirResults(respDecompression);
      const filterBrands = airSearchResults
        ? getBrandsAvailableCloud(airSearchResults?.data?.options)
        : null;

      dispatch({
        type: SET_AIR_RESULTS,
        searchResults: airSearchResults,
        filterBrands,
        displayIndex,
      });

      let airResponses = selectCloudResultsFilteredByBrand(getState());

      if (!TRIPHUB_ENABLED || !TRIPEVENTS_ENABLED) {
        airResponses = getAirFilterByAlternateAirports(airResponses);
      }
      const departureAirportList = selectDepartureAirportListCloud(getState());
      const arrivalAirportList = selectArrivalAirportListCloud(getState());
      const filterByDetails = getAirFiltersByDetailsCloud(
        airResponses,
        departureAirportList,
        arrivalAirportList
      );
      dispatch(filterByStopAndVendor(filterByDetails));
    } catch (err) {
      dispatch(
        openAlert({
          title: i18n.t('AirSearchFailureMessage'),
          confirmText: i18n.t('ReSearch'),
          onConfirmPressed: () => RootNavigation.navigate('Home'),
        })
      );
      logException(err, { metaData: { travelRequestId, airComponentRequestId } });
      return;
    }
  };
};
function parseAndSortAirResults(airData) {
  const parsedAirData = JSON.parse(airData);
  if (parsedAirData?.data?.options) {
    parsedAirData.data.options = parsedAirData?.data?.options.map((result) => {
      result.fares = result.fares
        ?.filter((x) => x.isLowestFare)
        .sort((a, b) => parseFloat(a.total) - parseFloat(b.total));
      result.selectedBrand = 0;
      return result;
    });
  }
  return parsedAirData;
}
export const airBXSearch = (routeParams) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const accessToken = selectAccessToken(getState());
    const results = selectTripResults(getState());
    const travelRequestId = results.TravelRequestId;
    const requestedComponents = results.RequestedComponents;
    const airComponentRequestId = requestedComponents.find((x) => x.DisplayIndex === displayIndex)
      ?.ComponentRequestId;

    const { selectedDates, selectedAwardCode } = routeParams;
    dispatch({
      type: UPDATE_SEARCH_INPUT_DATES,
      selectedDates: selectedDates,
    });

    const [err, airSearchResults] = await to(
      searchBXAirApi(accessToken, travelRequestId, routeParams)
    );

    if (err) {
      dispatch(
        openAlert({
          title: i18n.t('AirSearchFailureMessage'),
          confirmText: i18n.t('ReSearch'),
          onConfirmPressed: () => RootNavigation.navigate('Home'),
        })
      );
      logException(err, { metaData: { travelRequestId, airComponentRequestId } });
      return;
    }

    if (airSearchResults?.AirResponses) {
      airSearchResults.AirResponses = airSearchResults.AirResponses.map((result) => {
        // making sure first multibrand is the lowest for the default brand
        result.MultiBrands = result.MultiBrands?.filter((x) => x.IsLowestFare).sort(
          (a, b) => parseFloat(a.TotalFare) - parseFloat(b.TotalFare)
        );
        result.selectedBrand = 0;

        return result;
      });
    }

    const filterBrands = airSearchResults
      ? getBrandsAvailable(airSearchResults.AirResponses)
      : null;

    const selectedBrandIdx = filterBrands?.findIndex(
      (brand) => brand.awardCode === selectedAwardCode.awardCode
    );
    dispatch({
      type: SET_AIR_RESULTS,
      searchResults: airSearchResults,
      filterByBrand: filterBrands?.[Math.max(selectedBrandIdx, 0)].brand,
      filterBrands,
      displayIndex,
    });

    dispatch({
      type: UPDATE_TRIP_SEARCH_RESULTS,
      tripResults: {
        ...airSearchResults,
        SelectedAward: selectedAwardCode?.text?.split(' ')[0].toLowerCase(),
      },
    });

    const airResponses = selectResultsFilteredByBrand(getState());
    const departureAirportList = selectDepartureAirportList(getState());
    const arrivalAirportList = selectArrivalAirportList(getState());
    const filterByDetails = getAirFiltersByDetails(
      airResponses,
      departureAirportList,
      arrivalAirportList
    );

    dispatch(filterByStopAndVendor(filterByDetails));
  };
};

export const orderBy = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());
    const { orderBy, reverse } = selectActiveAirComponent(getState());

    if (orderBy === key) {
      dispatch({
        type: ORDER_BY_REVERSE_AIR,
        reverse: !reverse,
        displayIndex,
      });
    } else {
      dispatch({
        type: ORDER_BY_AIR,
        reverse: false,
        orderBy: key,
        displayIndex,
      });
    }
  };
};

export const filterBy = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());

    dispatch({
      type: FILTER_BY_AIR,
      filterBy: key,
      displayIndex,
    });
  };
};

export const filterByBrand = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());

    dispatch({
      type: FILTER_BY_AIR_BRAND,
      filterByBrand: key,
      displayIndex,
    });

    const airResponses = selectResultsFilteredByBrand(getState());
    const departureAirportList = selectDepartureAirportList(getState());
    const arrivalAirportList = selectArrivalAirportList(getState());
    const filterByDetails = getAirFiltersByDetails(
      airResponses,
      departureAirportList,
      arrivalAirportList
    );

    dispatch(filterByStopAndVendor(filterByDetails));
  };
};
export const filterByBrandCloud = (key) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());

    dispatch({
      type: FILTER_BY_AIR_BRAND,
      filterByBrand: key,
      displayIndex,
    });

    const airResponses = selectCloudResultsFilteredByBrand(getState());
    const departureAirportList = selectDepartureAirportListCloud(getState());
    const arrivalAirportList = selectArrivalAirportListCloud(getState());
    const filterByDetails = getAirFiltersByDetailsCloud(
      airResponses,
      departureAirportList,
      arrivalAirportList
    );
    dispatch(filterByStopAndVendor(filterByDetails));
  };
};

export const filterByStopAndVendor = (filterByDetails) => {
  return async (dispatch, getState) => {
    const displayIndex = selectActiveComponentIndex(getState());

    dispatch({
      type: FILTER_BY_AIR_STOP_AND_VENDOR,
      filterByDetails: filterByDetails,
      displayIndex,
    });
  };
};
export const clearSelectedAirCache = (selectedAir) => {
  return async (dispatch) => {
    if (selectedAir && Object.keys(selectedAir).length !== 0) {
      dispatch({ type: CLEAR_AIR, selectedAir });
    }
  };
};
